import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { I18nService } from './i18n.service';

/** Lets the server answer (validation errors, messages...) in the user's interface language. */
@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
	private i18n = inject(I18nService);

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// only our own API: third parties could reject or be confused by the header
		const isApiCall = req.url.startsWith('/') || req.url.startsWith(environment.apiUrl);

		if (!isApiCall || req.headers.has('Accept-Language')) {
			return next.handle(req);
		}

		return next.handle(req.clone({ setHeaders: { 'Accept-Language': this.i18n.language } }));
	}
}
